import { combineReducers } from '@reduxjs/toolkit';
import { modalSliceReducer } from './modal/modalSlice';
import { topicSliceReducer } from './topic/topicSlice';

export const rootReducer = combineReducers({
    modal: modalSliceReducer,
    topic: topicSliceReducer,
});
